import React from 'react'
import type { FC } from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles'

import { Tooltip } from '@homeviews/shared-ui'

const useStyles = makeStyles((theme) =>
  createStyles({
    div: {
      padding: '19px 40px 10px 32px',
    },
    table: {
      width: '100%',
      backgroundColor: theme.colors.white,
      textAlign: 'center',
    },
    thead: {
      backgroundColor: '#000433',
      color: '#fff',
    },
    tr: {
      height: '35px',
    },
    th: {
      width: '50%',
      fontWeight: 500,
      color: theme.colors.white,
    },
    tbody: {
      backgroundColor: theme.colors.white,
      color: theme.colors.grey600,
    },
    td: {
      border: `1px solid ${theme.colors.grey250}`,
      color: theme.colors.grey600,
      fontWeight: 400,
    },
    p: {
      margin: '28px 0 0 0',
      fontWeight: 400,
      letterSpacing: '-0.23px',
      textAlign: 'center',
      color: theme.colors.grey600,
    },
  }),
)

const ReactNodeContent = () => {
  const classes = useStyles()
  return (
    <div className={classes.div}>
      <table className={classes.table}>
        <thead className={classes.thead}>
          <tr className={classes.tr}>
            <th className={classes.th}>First Name</th>
            <th className={classes.th}>Email Address</th>
          </tr>
        </thead>
        <tbody className={classes.tbody}>
          <tr className={classes.tr}>
            <td className={classes.td}>John</td>
            <td className={classes.td}>john@gmail.com</td>
          </tr>
          <tr className={classes.tr}>
            <td className={classes.td} />
            <td className={classes.td} />
          </tr>
          <tr className={classes.tr}>
            <td className={classes.td} />
            <td className={classes.td} />
          </tr>
        </tbody>
      </table>
      <p className={classes.p}>
        Please ensure the spreadsheet is formatted with First Name only and
        email address in the format shown above.
      </p>
    </div>
  )
}

export const UploadTooltip: FC = () => (
  <Tooltip
    content={<ReactNodeContent />}
    layout="light"
    borderRadiusPx={6}
    maxWidthPx={468}
  />
)
